module.exports = __webpack_public_path__ + "img/whatsapp.fee63bb6.svg";